module.exports = __webpack_public_path__ + "static/media/manageSubmittedData.847e4e3b.svg";